import { Card, CardContent } from '@/components/ui/card';
import { useEirsaliyeStats } from '@/hooks/use-eirsaliye';
import { FileText, Calendar, Package, AlertTriangle, Clock } from 'lucide-react';

export function EirsaliyeStatsCards() {
  const { data: stats, isLoading } = useEirsaliyeStats();

  const cards = [
    {
      label: 'Toplam Irsaliye',
      value: stats?.total_count ?? 0,
      icon: FileText,
      color: 'text-blue-600',
    },
    {
      label: 'Bu Ay',
      value: stats?.this_month_count ?? 0,
      icon: Calendar,
      color: 'text-green-600',
    },
    {
      label: 'Toplam Adet',
      value: stats?.total_adet ?? 0,
      icon: Package,
      color: 'text-purple-600',
    },
    {
      label: 'Inceleme Bekleyen',
      value: stats?.needs_review_count ?? 0,
      icon: AlertTriangle,
      color: stats?.needs_review_count ? 'text-orange-600' : 'text-muted-foreground',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.label}>
          <CardContent className="pt-6 text-center">
            <div className={`text-3xl font-bold ${card.color}`}>
              {isLoading ? '...' : card.value.toLocaleString('tr-TR')}
            </div>
            <div className="text-xs text-muted-foreground mt-1 flex items-center justify-center gap-1">
              <card.icon className="w-3 h-3" />
              {card.label}
            </div>
          </CardContent>
        </Card>
      ))}

      {stats?.last_sync_at && (
        <div className="col-span-2 md:col-span-4 text-xs text-muted-foreground flex items-center gap-1">
          <Clock className="w-3 h-3" />
          Son senkronizasyon: {new Date(stats.last_sync_at).toLocaleString('tr-TR')}
        </div>
      )}
    </div>
  );
}
